"use strict";

import {
  serviceRequestConstants,
  commonConstants,
  responseCodes,
  serviceRequestOtpTimeoutStatusCodes,
} from "../_constants";

const getInitialState = () => ({
  serviceRequestList: [],
  serviceRequestTemplateCategories: [],
  selectedServiceRequestCategory: {},
  serviceRequestTemplateList: [],
  serviceRequestTemplateFieldsList: [],
  serviceRequestAssetOptions: {},
  selectedServiceRequestTemplate: {},
  serviceRequestValidateResponse: {},
  serviceRequestInitiateResponse: {},
  serviceRequestInitiateData: [],
  serviceRequestOtpResponse: {},
  serviceRequestOtpTimer: 0,
  isPaginatingServiceRequestList: false,
  serviceRequestFilterCategoryList: [],
  serviceRequestFilterTemplateList: [],
  serviceRequestFilterStatusList: [],
  serviceRequestDetail: {},
  serviceRequestAssetOptions: {},
  isPaginatingAssetOptions: {},
  hasMoreAssetOptions: {},
  serviceRequestCancelResponse: {},
  externalServiceRequestData: null,
  termsAndConditionRequired: commonConstants.NO_OPTION_TYPE,
  termsAndConditionUrl: "",
  receiptAvailability: commonConstants.NO_OPTION_TYPE,
});

export function serviceRequest(state = getInitialState(), action) {
  switch (action.type) {
    case serviceRequestConstants.SERVICE_REQUEST_LIST_REQUEST:
      return {
        ...state,
      };
    case serviceRequestConstants.SERVICE_REQUEST_LIST_COMPLETE: {
      const newItems = action.payload.data?.customerServiceRequests ?? [];
      const serviceRequestList = state.isPaginatingServiceRequestList
        ? [...state.serviceRequestList, ...newItems]
        : [...newItems];
      serviceRequestList.isEmpty = newItems.length === 0;

      return {
        ...state,
        isPaginatingServiceRequestList: state.isPaginatingServiceRequestList,
        serviceRequestList,
      };
    }

    case serviceRequestConstants.SERVICE_REQUEST_LIST_ERROR: {
      const serviceRequestList = [];
      serviceRequestList.isEmpty = true;

      return {
        ...state,
        serviceRequestList,
      };
    }

    case serviceRequestConstants.SET_IS_PAGINATING_SERVICE_REQUEST_LIST:
      return {
        ...state,
        isPaginatingServiceRequestList: action.payload,
      };

    case serviceRequestConstants.SERVICE_REQUEST_TEMPLATE_CATEGORIES_LIST_REQUEST:
      return {
        ...state,
        serviceRequestTemplateCategories: [],
      };
    case serviceRequestConstants.SERVICE_REQUEST_TEMPLATE_CATEGORIES_LIST_COMPLETE:
      return {
        ...state,
        serviceRequestTemplateCategories:
          action.payload.data?.serviceRequestTemplatesCategories,
      };

    case serviceRequestConstants.SERVICE_REQUEST_TEMPLATE_CATEGORIES_LIST_ERROR:
      return {
        ...state,
        serviceRequestTemplateCategories: [],
      };

    case serviceRequestConstants.SERVICE_REQUEST_TEMPLATE_LIST_REQUEST:
      return {
        ...state,
        serviceRequestTemplateList: [],
        serviceRequestTemplateFieldsList: [],
        serviceRequestAssetOptions: {},
        selectedServiceRequestTemplate: {},
        serviceRequestInitiateData: [],
      };
    case serviceRequestConstants.SERVICE_REQUEST_TEMPLATE_LIST_COMPLETE:
      return {
        ...state,
        serviceRequestTemplateList:
          action.payload.data?.serviceRequestTemplates,
        selectedServiceRequestCategory:
          action?.payload?.data?.serviceRequestTemplateCategory,
      };

    case serviceRequestConstants.SERVICE_REQUEST_TEMPLATE_LIST_ERROR:
      return {
        ...state,
        serviceRequestTemplateList: [],
      };

    case serviceRequestConstants.SET_SERVICE_REQUEST_CATEGORY:
      return {
        ...state,
        selectedServiceRequestCategory: action.payload,
      };

    case serviceRequestConstants.SET_SERVICE_REQUEST_INITIATE_DATA:
      return {
        ...state,
        serviceRequestInitiateData: action.payload,
      };

    case serviceRequestConstants.CLEAR_SERVICE_REQUEST_INITIATE_DATA:
      return {
        ...state,
        serviceRequestInitiateData: [],
      };

    case serviceRequestConstants.SET_SERVICE_REQUEST_TEMPLATE:
      return {
        ...state,
        selectedServiceRequestTemplate: action.payload,
      };

    case serviceRequestConstants.CLEAR_SERVICE_REQUEST_CATEGORY:
      return {
        ...state,
        selectedServiceRequestCategory: {},
        serviceRequestTemplateList: [],
        serviceRequestTemplateFieldsList: [],
        serviceRequestAssetOptions: {},
        selectedServiceRequestTemplate: {},
        serviceRequestInitiateData: [],
      };
    case serviceRequestConstants.CLEAR_SERVICE_REQUEST:
      return getInitialState();

    case serviceRequestConstants.SERVICE_REQUEST_TEMPLATE_FIELDS_REQUEST:
      return {
        ...state,
        serviceRequestTemplateFieldsList: [],
      };
    case serviceRequestConstants.SERVICE_REQUEST_TEMPLATE_FIELDS_COMPLETE:
      return {
        ...state,
        serviceRequestTemplateFieldsList: action.payload.data?.fields,
        selectedServiceRequestTemplate:
          action.payload?.data?.serviceRequestTemplate,
        termsAndConditionRequired:
          action.payload?.data?.termsAndConditionRequired ??
          commonConstants.NO_OPTION_TYPE,
        termsAndConditionUrl: action.payload?.data?.termsAndConditionUrl ?? "",
        receiptAvailability:
          action.payload?.data?.receiptAvailability ??
          commonConstants.NO_OPTION_TYPE,
      };

    case serviceRequestConstants.SERVICE_REQUEST_TEMPLATE_FIELDS_ERROR:
      return {
        ...state,
        serviceRequestTemplateFieldsList: [],
      };

    case serviceRequestConstants.SET_IS_PAGINATING_ASSET_OPTIONS: {
      const { asset, isPaginating } = action.payload;
      return {
        ...state,
        isPaginatingAssetOptions: {
          ...state.isPaginatingAssetOptions,
          [asset]: isPaginating,
        },
      };
    }

    case serviceRequestConstants.SERVICE_REQUEST_ASSETS_OPTIONS_REQUEST:
      return {
        ...state,
      };
    case serviceRequestConstants.SERVICE_REQUEST_ASSETS_OPTIONS_COMPLETE: {
      const data = action.payload?.data || {};
      const asset = data.asset;
      const list = data.dataList ?? data.data ?? [];
      const prev = state.serviceRequestAssetOptions[asset] ?? [];
      const isPaginating = !!state.isPaginatingAssetOptions[asset];

      const merged = isPaginating ? [...prev, ...list] : list;

      const hasMore = !(list.length === 0);

      return {
        ...state,
        serviceRequestAssetOptions: {
          ...state.serviceRequestAssetOptions,
          [asset]: merged,
        },
        hasMoreAssetOptions: {
          ...state.hasMoreAssetOptions,
          [asset]: hasMore,
        },
        isPaginatingAssetOptions: {
          ...state.isPaginatingAssetOptions,
          [asset]: false,
        },
      };
    }

    case serviceRequestConstants.SERVICE_REQUEST_ASSETS_OPTIONS_ERROR:
      return {
        ...state,
        serviceRequestAssetOptions: { ...state.serviceRequestAssetOptions },
        isPaginatingAssetOptions: {
          ...state.isPaginatingAssetOptions,
          [action.payload?.asset]: false,
        },
      };

    case serviceRequestConstants.CLEAR_SERVICE_REQUEST_ASSET_OPTION: {
      const assetKey = action.payload;
      if (!assetKey) return state;

      const nextAssetOptions = { ...state.serviceRequestAssetOptions };
      delete nextAssetOptions[assetKey];

      return {
        ...state,
        serviceRequestAssetOptions: nextAssetOptions,
        hasMoreAssetOptions: {
          ...state.hasMoreAssetOptions,
          [assetKey]: false,
        },
        isPaginatingAssetOptions: {
          ...state.isPaginatingAssetOptions,
          [assetKey]: false,
        },
      };
    }

    case serviceRequestConstants.CLEAR_SERVICE_REQUEST_TEMPLATE_FIELDS:
      return {
        ...state,
        serviceRequestTemplateFieldsList: [],
        serviceRequestAssetOptions: {},
      };

    case serviceRequestConstants.SERVICE_REQUEST_VALIDATE_REQUEST:
      return {
        ...state,
        serviceRequestValidateResponse: {},
      };
    case serviceRequestConstants.SERVICE_REQUEST_VALIDATE_COMPLETE:
      return {
        ...state,
        serviceRequestValidateResponse: action.payload.data,
      };

    case serviceRequestConstants.SERVICE_REQUEST_VALIDATE_ERROR:
      return {
        ...state,
        serviceRequestValidateResponse: {},
      };

    case serviceRequestConstants.SERVICE_REQUEST_INITIATE_REQUEST:
      return {
        ...state,
        serviceRequestInitiateResponse: {
          serviceRequestId: state.serviceRequestInitiateResponse?.serviceRequestId,
          customer: state.serviceRequestInitiateResponse?.customer,
        },
      };
    case serviceRequestConstants.SERVICE_REQUEST_INITIATE_COMPLETE:
      return {
        ...state,
        serviceRequestInitiateResponse: action.payload?.data ?? {},
        serviceRequestOtpTimer: action.payload?.data?.otpTimerTimePeriod,
      };

    case serviceRequestConstants.SERVICE_REQUEST_INITIATE_ERROR: {
      const initiateErrorDetails = action?.payload?.response?.errorDetails;
      return {
        ...state,
        serviceRequestInitiateResponse: {
          ...state.serviceRequestInitiateResponse,
          customer:
            initiateErrorDetails?.customer ??
            state.serviceRequestInitiateResponse?.customer,
        },
        serviceRequestOtpTimer: initiateErrorDetails?.remainingTime,
      };
    }

    case serviceRequestConstants.CLEAR_SERVICE_REQUEST_RESPONSES:
      return {
        ...state,
        serviceRequestValidateResponse: {},
        serviceRequestInitiateResponse: {},
        serviceRequestOtpResponse: {},
        serviceRequestOtpTimer: 0,
      };

    case serviceRequestConstants.SERVICE_REQUEST_OTP_REQUEST:
      return {
        ...state,
        serviceRequestOtpResponse: {},
      };
    case serviceRequestConstants.SERVICE_REQUEST_OTP_COMPLETE:
      return {
        ...state,
        serviceRequestOtpResponse: action.payload?.data ?? {},
        serviceRequestOtpTimer: 0,
      };

    case serviceRequestConstants.SERVICE_REQUEST_OTP_ERROR: {
      const otpErrorStatusCode = action?.payload?.response?.statusCode;
      const isOtpTimeout =
        action?.payload?.response?.isTimeout ||
        serviceRequestOtpTimeoutStatusCodes.includes(otpErrorStatusCode) ||
        !action?.payload?.response;

      if (isOtpTimeout) {
        return {
          ...state,
          serviceRequestOtpResponse: {
            serviceRequestStatus:
              serviceRequestConstants.SERVICE_REQUEST_FAILED_STATUS,
            responseCode: responseCodes.SERVICE_ERROR_CODE,
          },
          serviceRequestOtpTimer: 0,
        };
      }

      return {
        ...state,
        serviceRequestOtpResponse: {},
        serviceRequestOtpTimer:
          action?.payload?.response?.errorDetails?.remainingTime ??
          state.serviceRequestOtpTimer,
      };
    }

    case serviceRequestConstants.SERVICE_REQUEST_RESEND_OTP_REQUEST:
      return state;
    case serviceRequestConstants.SERVICE_REQUEST_RESEND_OTP_COMPLETE: {
      const resendOtpResponseData = action.payload?.data ?? {};
      return {
        ...state,
        serviceRequestInitiateResponse: {
          ...resendOtpResponseData,
          resendOtp: true,
        },
        serviceRequestOtpTimer: resendOtpResponseData?.otpTimerTimePeriod,
      };
    }

    case serviceRequestConstants.SERVICE_REQUEST_RESEND_OTP_ERROR: {
      const resendErrorDetails = action?.payload?.response?.errorDetails;
      return {
        ...state,
        serviceRequestInitiateResponse: {
          ...state.serviceRequestInitiateResponse,
          customer:
            resendErrorDetails?.customer ??
            state.serviceRequestInitiateResponse?.customer,
        },
        serviceRequestOtpTimer: resendErrorDetails?.remainingTime,
      };
    }

    case serviceRequestConstants.SERVICE_REQUEST_FILTER_DATA_REQUEST:
      return {
        ...state,
        serviceRequestFilterCategoryList: [],
        serviceRequestFilterTemplateList: [],
        serviceRequestFilterStatusList: [],
      };
    case serviceRequestConstants.SERVICE_REQUEST_FILTER_DATA_COMPLETE:
      return {
        ...state,
        serviceRequestFilterCategoryList: action.payload.data?.categoryList,
        serviceRequestFilterTemplateList: action.payload.data?.templateList,
        serviceRequestFilterStatusList: action.payload.data?.statusList,
      };

    case serviceRequestConstants.SERVICE_REQUEST_FILTER_DATA_ERROR:
      return {
        ...state,
        serviceRequestFilterCategoryList: [],
        serviceRequestFilterTemplateList: [],
        serviceRequestFilterStatusList: [],
      };

    case serviceRequestConstants.SERVICE_REQUEST_DETAILS_REQUEST:
      return {
        ...state,
        serviceRequestDetail: {},
      };
    case serviceRequestConstants.SERVICE_REQUEST_DETAILS_COMPLETE:
      return {
        ...state,
        serviceRequestDetail: action.payload.data,
      };

    case serviceRequestConstants.SERVICE_REQUEST_DETAILS_ERROR:
      return {
        ...state,
        serviceRequestDetail: {},
      };

    case serviceRequestConstants.CLEAR_SERVICE_REQUEST_DETAILS:
      return {
        ...state,
        serviceRequestDetail: {},
      };

    case serviceRequestConstants.SERVICE_REQUEST_CANCEL_REQUEST:
      return {
        ...state,
        serviceRequestCancelResponse: {},
      };
    case serviceRequestConstants.SERVICE_REQUEST_CANCEL_COMPLETE:
      return {
        ...state,
        serviceRequestCancelResponse: action.payload.data,
      };

    case serviceRequestConstants.SERVICE_REQUEST_CANCEL_ERROR:
      return {
        ...state,
        serviceRequestCancelResponse: {},
      };

    case serviceRequestConstants.SET_SERVICE_REQUEST_FROM_EXTERNAL:
      return {
        ...state,
        externalServiceRequestData: action.payload,
      };

    case serviceRequestConstants.CLEAR_SERVICE_REQUEST_FROM_EXTERNAL:
      return {
        ...state,
        externalServiceRequestData: null,
      };
  }

  return state;
}
